<header class="mb-1 text-center">
  <img
    src="/logos/default.webp"
    alt="ALLAS REPUESTOS - Logo de la empresa"
    class="h-14 md:h-16 mx-auto mb-1"
    title="ALLAS REPUESTOS"
  />
</header>
